/* eslint-disable i18next/no-literal-string */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../index.css';
import List from '@material-ui/core/List/List';
import ListItem from '@material-ui/core/ListItem/ListItem';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import { withTranslation } from 'react-i18next';
import FormControl from '@material-ui/core/FormControl';
import { IconButton } from '@material-ui/core';

const PLAY_ENTIRE_CARD = '_PLAY_ENTIRE_CARD_';

const BUTTON_PLAY_LIB_CARD = {
    cardId: '3nC80',
    card: {
        cardId: '3nC80',
        title: 'Yoto Daily',
        content: {
            chapters: [
                {
                    key: 'daily',
                    title: 'Yoto Daily',
                    tracks: [
                        {
                            key: '<yyyymmdd>',
                            title: 'Yoto Daily',
                        }
                    ]
                },
                {
                    key: 'radio-day',
                    title: 'Yoto Radio',
                    tracks: [
                        {
                            key: '01',
                            title: 'Yoto Radio'
                        }
                    ]
                },
                {
                    key: 'radio-night',
                    title: 'Yoto Sleep Radio',
                    tracks: [
                        {
                            key: '01',
                            title: 'Yoto Sleep Radio'
                        }
                    ]
                }
            ]
        }

    }
};

const TOOTHBRUSH_CARD = {
    cardId: 'TOOTHBRUSH',
    card: {
        cardId: '3nC80',
        title: 'Toothbrush Timer',
        content: {
            chapters: [
                {
                    key: 'timer-toothbrush',
                    title: 'Toothbrush Timer',
                    tracks: [
                        {
                            key: '01',
                            title: 'Toothbrush Timer',
                        }
                    ]
                }
            ]
        }
    }
};

class DeviceBetaRhbModeConfig extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mode: props.mode,
            cardItems: [],
            library: [],
            selectedCard: null,
            selectedChapter: null,
            selectedPosition: null,
            onChange: props.onChange
        };
    }

    async setState(state) {
        return super.setState(state);
    }

    async componentDidMount() {
        this.setState({ loading: true });
        const config = this.props.config || { content: [] };
        const cardItems = config.content.filter(c => c.cmd === 'track-play' || c.cmd === 'card-play').map(c => {
            if (c.card === BUTTON_PLAY_LIB_CARD.cardId) {
                if (c.params.chapter === TOOTHBRUSH_CARD.card.content.chapters[0].key) {
                    c.params.card = TOOTHBRUSH_CARD.card;
                }
            }
            return c;
        });
        // Hydrate and filter library before adding BUTTON_PLAY_LIB_CARD
        const updatedLibrary = [BUTTON_PLAY_LIB_CARD, TOOTHBRUSH_CARD, ...this.props.library];
        this.setState({
            cardItems,
            mode: this.props.mode,
            library: updatedLibrary,
            addingItem: false,
            loading: false,
            previousPosition: null,
        });
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.library !== this.props.library) {
            // Hydrate and filter library before adding BUTTON_PLAY_LIB_CARD
            const filteredLibrary = this.props.library;
            const updatedLibrary = [BUTTON_PLAY_LIB_CARD, ...filteredLibrary];
            this.setState({ library: updatedLibrary });
        }
        if (prevProps.config !== this.props.config) {
            const config = this.props.config || { content: [] };
            const cardItems = config.content.filter(c => c.cmd === 'track-play' || c.cmd === 'card-play');
            this.setState({ cardItems });
        }
    }


    async selectCard(selectedCard) {
        const { library } = this.state;
        const hydratedCard = library.find(c => c.cardId === selectedCard.cardId).card;
        const selectedChapter = (hydratedCard && hydratedCard.content && hydratedCard.content.chapters) ? hydratedCard.content.chapters[0] : null;
        this.setState({ selectedCard, selectedChapter });
    }

    async addEntry() {
        const { cardItems, selectedCard, selectedChapter, selectedPosition, previousPosition } = this.state;
        const entry = {};
        entry.cmd = selectedChapter && selectedChapter.key ? 'track-play' : 'card-play';
        entry.params = { card: selectedCard.cardId };
        if (selectedChapter && selectedChapter.key) {
            entry.params.chapter = selectedChapter.key;
            entry.params.track = selectedChapter.tracks[0].key;
        }
        if (previousPosition !== null)
            cardItems.splice(previousPosition, 1);
        cardItems.splice(selectedPosition, 0, entry);
        this.setState({ cardItems, selectedChapter: null, previousPosition: null, addingItem: false });
        this.save();
    }

    deleteEntry(index) {
        const { cardItems } = this.state;
        cardItems.splice(index, 1);
        this.setState({ cardItems });
        this.save();
    }

    save() {
        const { cardItems } = this.state;
        this.props.onChange({
            content: [...cardItems.map(c => {
                if (c.card === TOOTHBRUSH_CARD.cardId) {
                    c.params.card = TOOTHBRUSH_CARD.cardId;
                }
                return c;
            }) ]
        });
    }

    openAddDialog() {
        const { cardItems } = this.state;
        this.setState({
            addingItem: true,
            selectedPosition: cardItems.length,
            selectedCard: null,
            selectedChapter: null
        });
    }

    async openEditDialog(index) {
        const { cardItems } = this.state;
        const item = cardItems[index];
        const selectedCard = this.state.library.find(c => c.cardId === item.params.card).card;
        let selectedChapter = null;
        if (item.cmd === 'track-play') {
            await this.hydrateCard(selectedCard);
            selectedChapter = selectedCard.content.chapters.find(ch => ch.key === item.params.chapter);
        } else {
            selectedChapter = PLAY_ENTIRE_CARD;
        }
        this.setState({
            addingItem: true,
            previousPosition: index,
            selectedPosition: index,
            selectedCard,
            selectedChapter
        });
    }

    closeAddDialog() {
        this.setState({ addingItem: false, selectedPosition: null, previousPosition: null });
    }

    getCardTitle(cardId, chapterKey) {
        const libCard = (cardId === TOOTHBRUSH_CARD.card.cardId && chapterKey === TOOTHBRUSH_CARD.card.content.chapters[0].key) ? TOOTHBRUSH_CARD : this.state.library.find(c => (c.cardId === cardId));
        return  libCard ? libCard.card.title : 'Invalid card';
    }

    getTrackTitle(cardId, chapterKey, trackKey) {
        const libCard = (cardId === TOOTHBRUSH_CARD.card.cardId && chapterKey === TOOTHBRUSH_CARD.card.content.chapters[0].key) ? TOOTHBRUSH_CARD : this.state.library.find(c => (c.cardId === cardId));

        if (!libCard || !chapterKey || !trackKey) return '';
        const chapter = (libCard.card.content.chapters || []).find(ch => ch.key === chapterKey);
        if (!chapter) return 'Invalid track';
        const track = chapter.tracks.find(t => t.key === trackKey);
        if (!track) return 'Invalid track';
        return track.title;
    }

    render() {

        const { cardItems, library, selectedCard, selectedChapter, selectedPosition, mode, loading } = this.state;
        return (
            <div>
                <div className="divider-container">
                    <hr className="styled-divider" />
                    <img 
                        src={
                            mode === 'day' 
                                ? (window.devicePixelRatio > 1 ? '/img/Morning@2x.png' : '/img/Morning.png') 
                                : (window.devicePixelRatio > 1 ? '/img/Nighttime@2x.png' : '/img/Nighttime.png')
                        } 
                        alt={mode === 'day' ? 'Morning Icon' : 'Nighttime Icon'} 
                        className="divider-icon"
                        width='40px'
                    />
                </div>
                <h2 style={{ textTransform: 'capitalize' }}>In {mode} Mode</h2>
                {   loading ? 'Loading...' :
                    <div>
                        <List className={'rhbEntryList'}>
                            {cardItems.map((item, index) => [
                                // if index > 0, add a divider,
                                index > 0 && <Divider key={`rhb-divider-${mode}-${index}`} variant='middle' component='li' />,
                                (
                                    <ListItem 
                                        className={'rhbEntryListItem'} 
                                        key={`rhn-list-${mode}-${index}`} 
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 20px' }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div className={'circle-full'}>
                                                <div className={'circle-full-text'}>{index + 1}</div>
                                            </div>
                                            <div className='rhbEntryTitle' style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Button 
                                                    variant='text' 
                                                    color='secondary' 
                                                    onClick={() => this.openEditDialog(index)} 
                                                    style={{ padding: 0, textAlign: 'left', justifyContent: 'flex-start' }}
                                                >
                                                    {this.getCardTitle(item.params.card, item.params.chapter)}
                                                </Button>
                                                <div style={{ color: '#777', fontSize: '0.9em' }}>
                                                    {this.getTrackTitle(item.params.card, item.params.chapter, item.params.track)}
                                                </div>
                                            </div>
                                        </div>
                                        <IconButton 
                                            size={'large'} 
                                            aria-label="delete" 
                                            onClick={() => { this.deleteEntry(index); }} 
                                            style={{ marginLeft: 'auto' }}
                                        >
                                            <img 
                                                src={window.devicePixelRatio > 1 ? '/img/Delete@2x.png' : '/img/Delete.png'} 
                                                alt="Delete Icon" 
                                                width="30px" 
                                            />
                                        </IconButton>
                                    </ListItem>
                                )])
                            }

                        </List>
                        {cardItems.length < 8 && (
                            <Button variant="contained" color="secondary" onClick={() => this.openAddDialog()}>{cardItems.length ? 'Add another' : 'Add some audio'}</Button>
                        )}
                    </div>
                }


                <Dialog fullScreen open={this.state.addingItem || false} onClose={() => this.closeAddDialog()} aria-labelledby="form-dialog-title">
                    <DialogContent>
                        <h2>{this.state.previousPosition !== null ? 'Edit Shortcut' : 'Add a shortcut'}</h2>
                        <DialogContentText>
                            Choose from any of your single-track cards to add to the right hand button of your player.
                        </DialogContentText>
                        {cardItems.length > 0 ? (
                            <div>
                                <h3 style={{ marginBottom: '8px', width: '100%' }}>Position</h3>
                                <FormControl style={{ width: '100%' }}>
                                    <Select
                                        id="position-select"
                                        value={selectedPosition}
                                        onChange={(event) => {
                                            this.setState({ selectedPosition: event.target.value });
                                        }}
                                    >
                                        {cardItems ? [...Array(cardItems.length + 1).keys()].map((pos) => (
                                            <MenuItem key={`selected-chapter-${pos}`} value={pos}>
                                                <div className='circle-full'>
                                                    <div className='circle-full-text'>{pos + 1}</div>
                                                </div>
                                            </MenuItem>
                                        )) : null}
                                    </Select>
                                </FormControl>
                            </div>
                        ) : ''}
                        <div>
                            <h3 style={{ marginBottom: '8px', width: '100%' }}>Card</h3>
                            <FormControl style={{ width: '100%', marginBottom: '24px' }} variant="outlined">
                                <Autocomplete
                                    id="card-select"
                                    options={library.map((libCard) => libCard.card)}
                                    autoSelect
                                    value={selectedCard || ''}
                                    getOptionLabel={(option) => option.title}
                                    color='secondary'
                                    onChange={(event, newValue) => {
                                        this.selectCard(newValue);
                                        // For BUTTON_PLAY_LIB_CARD, don't auto-select chapter
                                        if (newValue && newValue.cardId !== BUTTON_PLAY_LIB_CARD.cardId) {
                                            this.setState({ selectedChapter: newValue.content.chapters[0] });
                                        } else {
                                            this.setState({ selectedChapter: null });
                                        }
                                    }}
                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                />
                            </FormControl>
                        </div>
                        {/* Show chapter/track select only for BUTTON_PLAY_LIB_CARD */}
                        {selectedCard && selectedCard.cardId === BUTTON_PLAY_LIB_CARD.cardId ? (
                            <>
                                <h3 style={{ marginBottom: '8px', width: '100%' }}>Chapter/Track</h3>
                                <FormControl style={{ width: '100%', marginBottom: '24px' }} variant="outlined">
                                    <Autocomplete
                                        disabled={!selectedCard}
                                        id="chapter-select"
                                        autoSelect
                                        value={selectedChapter}
                                        getOptionLabel={(option) => option.title}
                                        onChange={(event, newValue) => {
                                            this.setState({ selectedChapter: newValue });
                                        }}
                                        color='secondary'
                                        options={selectedCard.content.chapters}
                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                    />
                                </FormControl>
                            </>
                        ) : null}
                        <Button disabled={!this.state.selectedCard || (selectedCard && selectedCard.cardId === BUTTON_PLAY_LIB_CARD.cardId && !selectedChapter)} onClick={() => {
                            this.addEntry('day');
                            this.closeAddDialog();
                        }} color="primary" variant='contained' size='large' style={{ width: '100%', marginBottom: '24px' }}>
                                        Save Shortcut
                        </Button>
                        <Button onClick={() => this.closeAddDialog()} size='large' style={{ width: '100%' }} variant='outlined' color="secondary">
                                        Cancel
                        </Button>
                        {this.state.previousPosition !== undefined ? ([
                            <hr key='delete-divider' className="styled-divider" />,
                            <Button key='delete-context-button' onClick={() => {
                                this.deleteEntry(this.state.previousPosition);
                                this.closeAddDialog();
                            }} size='large' style={{ width: '100%' }} variant='outlined' color="default">
                                        Delete Shortcut
                            </Button>
                        ]) : ''}
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

DeviceBetaRhbModeConfig.propTypes = {
    config: PropTypes.object,
    mode: PropTypes.string,
    library: PropTypes.array,
    params: PropTypes.object,
    i18n: PropTypes.object,
    onChange: PropTypes.func
};

export default withTranslation()(DeviceBetaRhbModeConfig);
